<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-1-at-the-farm">
<h1>Chapter 1<br/> At the Farm</h1>
<p>
<img alt="" class="img-centre" src="media/file0.JPG"/>
</p>
<p>“Cock-a-doodle-doo.” Sunrise was <em>the</em> most special time of day for the birds at the farmyard. The rooster announced its arrival every morning. “Cock-a-doodle-doo,” he chanted, over and over again. The hens were nearly as much in awe of him as they were of the sunrise itself. It was a magical time of day.</p>
<p>Who could not help admiring the rooster? He crowed with his head held high, the curved feathers of his tail gleaming ever brighter as the sun rose to shine on them. How was it that the sunrise, although it happened every single day, never felt like an ordinary event? A sense of wonder came afresh each morning. It was such a deeply moving experience that many human beings who watched it, called it ‘mystical’ or ‘spiritual’.</p>
<p>But on <em>this</em> particular day, the peaceful scene was suddenly shattered. One of the farmers, Liesl, came storming out of the farmhouse, followed by her husband Fritz, who was trying in vain to calm her down; “Now, Liesl,” he kept saying, but she paid him no heed.</p>
<p>“I’ve told you a dozen times to stop all that crowing so early in the morning,” she screeched. “You keep waking us up. We want a long lie. I’m fed up telling you. If you don’t stop waking us up so early, I’ll have your tail for a feather duster!”</p>
<p>She even tried to whack him with a broom that she picked up from the ground. Luckily, she kept missing as he fluttered about, dodging the swipes. Finally, he made it up to his high perch, out of her reach. He and the hens gave a huge sigh of relief when the two farmers went back indoors.</p>
<p>As the meaning of the words sank in, terror gripped the flock. A feather duster? How could anyone even <em>think</em> of such a fate for the rooster? His beautiful tail plucked and made into a feather duster? It was a horrible thought. The rooster was really shaken by the outburst.</p>
<p>“I can’t stay here with these threats of violence,” he lamented. “What if she carried out her threat to take my tail for a feather duster?”</p>
<p>“She’s cruel!”</p>
<p>“She’s unfair!”</p>
<p>“Surely, she wouldn’t be so wicked!” were some of the responses from the hens.</p>
<p>“How did they come to be farmers anyway?” Lotte’s question was not directed at anyone in particular. She was just thinking aloud.</p>
<p>“They were left the farm by a relative. That was before we came,” said one, who had evidently kept her ears open. “They were left the farm? But they are very unsuited to being farmers.”</p>
<p>That was true. These new farmers were city people. They liked to go to bed late, and get up late. The old farmer had no children, and his young nephew had inherited the farm. When he took it over, this young man had thought a farmer’s life would be easy. So had his wife.</p>
<p>“It’s my instinct to crow. I can’t stop it,” said the rooster. “I’ll have to leave. I’ll have to go away.”</p>
<p>“Of course you can’t stop crowing. They’re totally unreasonable to suggest it.”</p>
<p>“Don’t leave us!”</p>
<p>“Don’t go away!”</p>
<p>“I have no choice.”</p>
<p>“I suppose not.”</p>
<p>“Keep in touch with us!”</p>
<p>This was some of their conversation, between sobs.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?f2bad11a